webpackJsonp([78839606078735],{

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(10);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(37);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = function List(props) {
	  var edges = props.edges,
	      theme = props.theme;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      "ul",
	      {
	        className: _style2.default.dynamic([["132031231", [theme.space.stack.m, theme.space.m, theme.space.xs, theme.font.size.s, theme.font.lineHeight.l]]])
	      },
	      edges.map(function (edge) {
	        var _edge$node = edge.node,
	            title = _edge$node.frontmatter.title,
	            slug = _edge$node.fields.slug;
	
	
	        return _react2.default.createElement(
	          "li",
	          { key: slug, className: _style2.default.dynamic([["132031231", [theme.space.stack.m, theme.space.m, theme.space.xs, theme.font.size.s, theme.font.lineHeight.l]]])
	          },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: slug },
	            title
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(_style2.default, {
	      styleId: "132031231",
	      css: ["ul.__jsx-style-dynamic-selector{margin:" + theme.space.stack.m + ";padding:" + theme.space.m + ";list-style:circle;}", "li.__jsx-style-dynamic-selector{padding:" + theme.space.xs + " 0;font-size:" + theme.font.size.s + ";line-height:" + theme.font.lineHeight.l + ";}"],
	      dynamic: [theme.space.stack.m, theme.space.m, theme.space.xs, theme.font.size.s, theme.font.lineHeight.l]
	    })
	  );
	};
	
	List.propTypes = {
	  edges: _propTypes2.default.array.isRequired,
	  theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = List;
	module.exports = exports["default"];

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _List = __webpack_require__(114);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_List).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.categoryQuery = undefined;
	
	var _label = __webpack_require__(185);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Seo = __webpack_require__(52);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _layouts = __webpack_require__(34);
	
	var _Article = __webpack_require__(64);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _Headline = __webpack_require__(74);
	
	var _Headline2 = _interopRequireDefault(_Headline);
	
	var _List = __webpack_require__(115);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoryTemplate = function CategoryTemplate(props) {
	  var category = props.pathContext.category,
	      _props$data = props.data,
	      _props$data$allMarkdo = _props$data.allMarkdownRemark,
	      totalCount = _props$data$allMarkdo.totalCount,
	      edges = _props$data$allMarkdo.edges,
	      facebook = _props$data.site.siteMetadata.facebook;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _layouts.ThemeContext.Consumer,
	      null,
	      function (theme) {
	        return _react2.default.createElement(
	          _Article2.default,
	          { theme: theme },
	          _react2.default.createElement(
	            "header",
	            null,
	            _react2.default.createElement(
	              _Headline2.default,
	              { theme: theme },
	              _react2.default.createElement(
	                "span",
	                null,
	                "Posts in category"
	              ),
	              " ",
	              _react2.default.createElement(_label2.default, null),
	              category
	            ),
	            _react2.default.createElement(
	              "p",
	              { className: "meta" },
	              "There ",
	              totalCount > 1 ? "are" : "is",
	              " ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                totalCount
	              ),
	              " post",
	              totalCount > 1 ? "s" : "",
	              " ",
	              "in the category."
	            ),
	            _react2.default.createElement(_List2.default, { edges: edges, theme: theme })
	          )
	        );
	      }
	    ),
	    _react2.default.createElement(_Seo2.default, { facebook: facebook })
	  );
	};
	
	CategoryTemplate.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  pathContext: _propTypes2.default.object.isRequired
	};
	
	exports.default = CategoryTemplate;
	
	// eslint-disable-next-line no-undef
	
	var categoryQuery = exports.categoryQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-category-template-js-d4cba9221fc149adb496.js